import requests from 'service/api'
import AsyncSearchSelect from '../async-search-select'
import { firstOption, asOptions } from 'lib/asyncList'
import useTemNewStore from 'store/client/temNewStore'

export function SelectBodyChartHome({ name }) {
  const setSpecialValue = useTemNewStore((state) => state.setSpecialValue)
  const setAnotherValue = useTemNewStore((state) => state.setAnotherValue)
  const tabvalue = useTemNewStore((state) => state.tabvalue)

  const mapGroup = ({ id, name }) => ({ value: id, label: name })

  return (
    <AsyncSearchSelect
      label="Beden Tablosu"
      name={name}
      fetchSelected={(id) =>
        firstOption(requests.size.listGroupHome('', { selected: id }), mapGroup)
      }
      fetchOptions={(search) =>
        asOptions(
          requests.size.listGroupHome('', { search, limit: 20 }),
          mapGroup
        )
      }
      onChange={(option) => {
        const id = option?.value || ''
        if (tabvalue === '0') setSpecialValue(id)
        if (tabvalue === '2' || tabvalue === '3' || tabvalue === '4') setAnotherValue(id)
      }}
    />
  )
}
